var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _g4, _path23, _path24, _path25, _g5, _path26, _path27, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg1MetuaaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 51,
    viewBox: "0 0 73 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9999 45.6948H61.1451V48.562H71.9999V45.6948Z",
    fill: "url(#paint0_linear_3282_1571)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4813 45.6948H7.18225V48.562H61.4813V45.6948Z",
    fill: "#1D0C17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.5571H8.07195V45.6899H0V48.5571Z",
    fill: "url(#paint1_linear_3282_1571)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6288 43.7168H8.94174V40.13H27.4889L28.6288 43.7168Z",
    fill: "#1D0C17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5451 43.7168H35.6708V40.13H67.4052L68.5451 43.7168Z",
    fill: "#1D0C17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4457 32.2017H26.0908C24.1606 32.2017 22.5901 35.292 22.5901 39.1018C22.5901 42.9115 24.1555 46.0019 26.0908 46.0019H31.4457C33.3759 46.0019 34.9464 42.9115 34.9464 39.1018C34.9464 35.292 33.381 32.2017 31.4457 32.2017Z",
    fill: "#1D0C17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2176 21.5658H55.839C55.839 21.5658 57.3234 23.2174 57.4146 23.5771C57.5058 23.9368 57.369 25.2337 57.369 25.2337L53.5998 24.7423L49.4 22.0977L49.2176 21.5658Z",
    fill: "#A1989B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0508 32.2017H30.6959C28.7657 32.2017 27.1952 35.292 27.1952 39.1018C27.1952 42.9115 28.7606 46.0019 30.6959 46.0019H36.0508C37.981 46.0019 39.5515 42.9115 39.5515 39.1018C39.5515 35.292 37.9861 32.2017 36.0508 32.2017Z",
    fill: "#1D0C17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0736 32.2017H4.04797C2.23429 32.2017 0.765106 35.292 0.765106 39.1018C0.765106 42.9115 2.23429 46.0019 4.04797 46.0019H9.0736C10.8873 46.0019 12.3565 42.9115 12.3565 39.1018C12.3565 35.292 10.8873 32.2017 9.0736 32.2017Z",
    fill: "#1D0C17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2837 32.247H61.9288C59.9986 32.247 58.4281 35.3374 58.4281 39.1471C58.4281 42.9569 59.9935 46.0472 61.9288 46.0472H67.2837C69.2139 46.0472 70.7844 42.9569 70.7844 39.1471C70.7844 35.3374 69.219 32.247 67.2837 32.247Z",
    fill: "#1D0C17"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.764363 39.1113C0.755552 38.8566 0.350403 29.0591 0.350403 29.0591L10.2084 30.3071L9.53456 37.9823C9.53456 37.9823 7.63475 37.4757 7.5081 37.4757C7.38144 37.4757 5.1878 33.975 5.1878 33.975L3.71355 33.3012L2.40648 34.1422L0.861996 39.084L0.764363 39.1113Z",
    fill: "#1D0C17"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0375 32.8805L33.7001 30.1397L29.556 29.3798L25.2548 30.6869V41.4829L27.4484 41.0218L27.6156 38.4077L28.0817 35.5403L29.4293 33.5594L35.0375 32.8856V32.8805Z",
    fill: "#1D0C17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 42.3288H70.3941C71.1119 39.9025 72.5202 34.1828 71.6375 32.2434C71.6172 31.985 70.7437 31.8014 70.2371 31.2491C69.852 30.8337 70.0294 30.0535 69.3556 29.6837C68.6818 29.3088 67.4314 28.802 66.0686 28.1687C62.1018 26.3347 52.1814 23.3261 52.1814 23.3261L47.1506 18.1329C47.1506 18.1329 47.4901 17.7377 46.6693 17.0994C45.8486 16.4611 40.0438 15.23 32.3582 15.23C24.6726 15.23 20.9117 15.23 18.9474 15.23C16.9831 15.23 14.3372 15.5998 10.9986 17.91C7.65492 20.2252 5.55754 22.8647 3.47028 23.9539C1.46915 25.0026 -3.05176e-05 25.0077 -3.05176e-05 25.0077L0.694032 32.1104C0.694032 32.1104 1.10439 31.6038 2.05683 29.1771C3.01433 26.7555 31.5621 29.5571 32.8438 30.6209C33.0667 30.8084 33.2643 31.0262 33.4112 31.2694C34.4042 32.8855 35.7619 34.684 36.2027 37.6578C36.6434 40.6317 36.9525 42.3187 36.9525 42.3187L36.9474 42.3288Z",
    fill: "#E7E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3282_1571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 72,
    height: 28
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9474 42.3288H70.3941C71.1118 39.9025 72.5201 34.1828 71.6374 32.2434C71.6172 31.985 70.7437 31.8014 70.237 31.2491C69.852 30.8337 70.0293 30.0535 69.3555 29.6837C68.6817 29.3088 67.4314 28.802 66.0686 28.1687C62.1018 26.3347 52.1814 23.3261 52.1814 23.3261L47.1506 18.1329C47.1506 18.1329 47.49 17.7377 46.6693 17.0994C45.8486 16.4611 40.0437 15.23 32.3581 15.23C24.6725 15.23 20.9116 15.23 18.9474 15.23C16.9831 15.23 14.3371 15.5998 10.9986 17.91C7.65489 20.2252 5.55751 22.8647 3.47025 23.9539C1.46912 25.0026 -6.10352e-05 25.0077 -6.10352e-05 25.0077L0.694001 32.1104C0.694001 32.1104 1.10436 31.6038 2.0568 29.1771C3.0143 26.7555 31.562 29.5571 32.8438 30.6209C33.0667 30.8084 33.2643 31.0262 33.4112 31.2694C34.4042 32.8855 35.7619 34.684 36.2026 37.6578C36.6434 40.6317 36.9524 42.3187 36.9524 42.3187L36.9474 42.3288Z",
    fill: "#E7E5E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3282_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6773 24.7289L19.4492 -0.211792L6.08469 31.7607L60.3128 56.7013L73.6773 24.7289Z",
    fill: "url(#paint2_linear_3282_1571)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M74.8626 38.4584H33.4975V41.3005H74.8626V38.4584Z",
    fill: "url(#paint3_linear_3282_1571)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0755 32.4333C36.5253 29.4051 31.8358 26.6998 30.3413 25.8943C29.1204 25.2408 28.6036 24.5163 28.0109 23.569C27.2104 22.2974 24.5963 18.4927 22.8839 17.0488C21.1716 15.605 19.287 15.1186 15.457 15.7164C14.1549 16.1015 12.6452 16.7651 10.9987 17.905C7.65508 20.2202 5.55769 22.8597 3.47044 23.9489C1.46931 24.9976 0.00012207 25.0078 0.00012207 25.0078L0.527002 33.1693C1.4845 30.8845 2.97902 30.4336 4.35195 30.8693C5.97311 31.381 7.7412 33.4277 8.83042 38.0987C9.43836 40.7128 9.34717 41.5183 10.0463 41.5183H26.8051C25.9591 38.656 26.1111 34.9982 27.0179 33.1339C27.8994 31.3151 29.7131 29.9473 32.1499 31.4874C34.5817 33.0224 35.8482 37.278 35.9597 42.3289H38.4826C38.966 37.7332 38.8911 34.0267 38.0755 32.4333Z",
    fill: "#B9B2B4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3282_1571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 39,
    height: 28
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0755 32.4333C36.5254 29.4051 31.8358 26.6999 30.3413 25.8944C29.1204 25.2409 28.6036 24.5164 28.0109 23.569C27.2105 22.2974 24.5963 18.4927 22.884 17.0489C21.1716 15.605 19.287 15.1187 15.457 15.7165C14.155 16.1015 12.6453 16.7652 10.9988 17.9051C7.65511 20.2203 5.55772 22.8598 3.47047 23.949C1.46934 24.9977 0.000152588 25.0078 0.000152588 25.0078L0.527032 33.1694C1.48453 30.8845 2.97905 30.4337 4.35198 30.8694C5.97315 31.381 7.74123 33.4278 8.83045 38.0987C9.43839 40.7129 9.3472 41.5184 10.0463 41.5184H26.8052C25.9591 38.656 26.1111 34.9983 27.0179 33.1339C27.8994 31.3152 29.7131 29.9473 32.1499 31.4874C34.5817 33.0225 35.8482 37.278 35.9597 42.329H38.4826C38.9661 37.7333 38.8912 34.0267 38.0755 32.4333Z",
    fill: "#B9B2B4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3282_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9904 26.72H-1.80847V40.6012H40.9904V26.72Z",
    fill: "url(#paint4_linear_3282_1571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2682 51.5343L3.92651 19.7036L24.3431 4.4292L48.0274 36.2598L26.2682 51.5343Z",
    fill: "url(#paint5_linear_3282_1571)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1884 29.7043C67.4153 30.0032 67.3291 32.6325 67.3291 32.6325L71.7265 32.6072C71.7265 32.6072 71.6455 31.0266 69.3809 29.6942C69.3607 29.679 69.2137 29.6992 69.1884 29.7043Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0593 16.5267C24.0593 16.5267 28.5586 16.2785 34.2327 16.4C40.8248 16.4684 46.6695 17.0942 46.6695 17.0942L56.0115 24.5262H30.6149C30.6149 24.5262 28.1021 21.1471 27.2307 20.0173C26.2833 18.7812 24.3886 16.8307 24.0542 16.5267H24.0593Z",
    fill: "#16A34A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0116 22.8139L9.07859 24.8809H22.7724C22.7724 24.8809 27.4231 24.4857 27.4586 24.5465C27.2559 23.513 25.3156 20.3923 23.0409 18.2543C20.7662 16.1164 16.6069 16.1823 14.008 17.3526C10.7403 18.8167 7.57901 22.6518 7.0116 22.8139Z",
    fill: "#16A34A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88445 25.8182C1.29678 25.8587 0.511526 25.8942 0.0505066 25.8334L0.323084 30.0354C0.323084 30.0354 1.11946 30.0433 1.3981 29.5418C1.67167 29.0504 1.92498 27.6015 1.88445 25.8182Z",
    fill: "#746A6E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3282_1571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 33,
    width: 5,
    height: 12
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38812 39.279C1.38812 36.3102 2.42162 33.9089 3.69322 33.9089C4.96482 33.9089 5.99832 36.3153 5.99832 39.279C5.99832 42.2427 4.96482 44.6491 3.69322 44.6491C2.42162 44.6491 1.38812 42.2427 1.38812 39.279Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3282_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98819 39.279C5.98819 42.2478 4.95976 44.6491 3.68815 44.6491C2.41655 44.6491 1.38812 42.2427 1.38812 39.279C1.38812 36.3153 2.41655 33.9089 3.68815 33.9089C4.95976 33.9089 5.98819 36.3153 5.98819 39.279Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-3.10043 36.6043L4.92941 32.1359L10.5883 43.6158L2.55846 48.0842L-3.10043 36.6043Z",
    fill: "url(#paint6_linear_3282_1571)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M4.88893 39.3602C4.88893 41.3765 4.22526 43.0078 3.40961 43.0078C2.59396 43.0078 1.9303 41.3765 1.9303 39.3602C1.9303 37.3438 2.59396 35.7125 3.40961 35.7125C4.22526 35.7125 4.88893 37.3489 4.88893 39.3602Z",
    fill: "#746A6E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3282_1571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 33,
    width: 6,
    height: 12
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8588 39.279C27.8588 36.3102 28.9582 33.9089 30.3108 33.9089C31.6635 33.9089 32.7629 36.3153 32.7629 39.279C32.7629 42.2427 31.6635 44.6491 30.3108 44.6491C28.9582 44.6491 27.8588 42.2427 27.8588 39.279Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3282_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7629 39.279C32.7629 42.2478 31.6635 44.6491 30.3108 44.6491C28.9582 44.6491 27.8588 42.2427 27.8588 39.279C27.8588 36.3153 28.9582 33.9089 30.3108 33.9089C31.6635 33.9089 32.7629 36.3153 32.7629 39.279Z",
    fill: "#746A6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.1091 48.0787L37.6416 43.6124L31.634 32.1355L23.1015 36.6019L29.1091 48.0787Z",
    fill: "url(#paint7_linear_3282_1571)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M31.6433 39.431C31.6433 41.6702 30.9188 43.4839 30.0221 43.4839C29.1254 43.4839 28.401 41.6702 28.401 39.431C28.401 37.1917 29.1254 35.3781 30.0221 35.3781C30.9188 35.3781 31.6433 37.1917 31.6433 39.431Z",
    fill: "#746A6E"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7478 29.3848C67.7498 29.5875 66.539 29.937 65.8398 30.8793C65.4447 31.4164 65.2927 32.7285 65.2927 32.7285C65.2927 32.7285 69.3912 32.8551 71.7875 32.7285C71.6457 32.2371 71.0124 30.2815 68.7478 29.3848Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 28.588C43.3233 28.6138 44.8978 28.7768 46.6799 29.1573C49.623 29.7856 50.9301 31.1332 51.0061 32.7189C47.8137 32.9118 44.8812 32.8735 42.9075 32.7169C42.8814 31.8773 42.7158 30.1108 41.8333 28.588ZM41.2327 28.5851C42.1685 30.0146 42.3614 31.8101 42.3977 32.672C42.0443 32.6371 41.7301 32.5994 41.4612 32.5568C40.8736 32.4655 40.2203 31.8572 39.6428 31.2443C38.6146 30.1455 37.7967 28.8261 37.7883 28.8126L37.7932 28.8077C38.9386 28.6805 40.0645 28.593 41.2327 28.5851Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3282_1571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 50,
    height: 9
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0592 16.5267C24.0592 16.5267 31.8053 16.2785 37.4794 16.4C43.1535 16.5267 46.6694 17.0941 46.6694 17.0941L56.0114 24.5261H30.6148C30.6148 24.5261 28.102 21.147 27.2306 20.0173C26.2832 18.7811 24.3885 16.8307 24.0541 16.5267H24.0592ZM7.0116 22.8138L9.07859 24.8808H22.7724C22.7724 24.8808 27.4231 24.4856 27.4586 24.5464C27.2559 23.5129 25.3156 20.3922 23.0409 18.2543C20.7662 16.1163 16.6069 16.1822 14.008 17.3525C10.7403 18.8166 7.57901 22.6517 7.0116 22.8138Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3282_1571)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.75848,
    y: 26.4972,
    width: 10.8723,
    height: 58.798,
    transform: "rotate(-90 -1.75848 26.4972)",
    fill: "url(#paint8_linear_3282_1571)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4607 24.5396H24.6439C24.1069 24.5396 22.8606 21.5658 22.8606 21.5658H19.902C19.902 21.5658 18.6456 22.5081 18.6456 23.4504C18.6456 24.3927 19.8108 25.6035 19.8108 25.6035H25.6572C27.562 25.6035 27.4607 24.5396 27.4607 24.5396Z",
    fill: "#CFCBCC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.596 19C60.7164 19 58.8796 18.4431 57.3159 17.3988C55.7523 16.3546 54.5367 14.8712 53.8191 13.1362C53.0961 11.4012 52.9141 9.48939 53.2782 7.64724C53.6424 5.8051 54.5474 4.1129 55.8754 2.78484C57.2088 1.45678 58.901 0.546416 60.7432 0.182271C62.5853 -0.181874 64.4971 0.000198854 66.2321 0.723134C67.9672 1.44071 69.4505 2.66167 70.4948 4.22C71.539 5.78368 72.0959 7.62047 72.0959 9.5001C72.0959 12.017 71.0892 14.4321 69.3113 16.21C67.5281 17.9932 65.1183 18.9946 62.6014 18.9946L62.596 19ZM61.5786 10.5176H66.7944V8.48264H63.6135V3.8023H61.5786V10.5176Z",
    fill: "#16A34A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3282_1571",
    x1: 61.15,
    y1: 47.1259,
    x2: 71.9999,
    y2: 47.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3282_1571",
    x1: 8.07195,
    y1: 47.126,
    x2: 0,
    y2: 47.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#1D0C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D0C17",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3282_1571",
    x1: 12.2147,
    y1: 15.5237,
    x2: 67.5472,
    y2: 40.9709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3282_1571",
    x1: 54.1775,
    y1: 39.3703,
    x2: 54.1775,
    y2: 41.4271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3282_1571",
    x1: 19.5909,
    y1: 31.1731,
    x2: 19.5909,
    y2: 41.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#746A6E",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3282_1571",
    x1: 31.2209,
    y1: 19.125,
    x2: 13.4709,
    y2: 30.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#746A6E",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#746A6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3282_1571",
    x1: 0.804031,
    y1: 41.1194,
    x2: 9.2225,
    y2: 36.7127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3282_1571",
    x1: 26.9612,
    y1: 41.1591,
    x2: 35.5008,
    y2: 36.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CFCBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CFCBCC",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#CFCBCC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3282_1571",
    x1: -1.75848,
    y1: 55.8962,
    x2: 9.11384,
    y2: 55.8962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115385,
    stopColor: "#42003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913462,
    stopColor: "#42003B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1MetuaaGreen);
export default __webpack_public_path__ + "static/media/img1_metuaa_green.014429a9026141177cc50e2acd1a03cd.svg";
export { ForwardRef as ReactComponent };